import { ErrorContainer } from './error-container';

export class GenericProviderError extends ErrorContainer {}
